import { render, staticRenderFns } from "./DsbInput.vue?vue&type=template&id=c460b81a"
import script from "./DsbInput.vue?vue&type=script&lang=js"
export * from "./DsbInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports